import { TOptionsValues } from '@/domain/FullCalendar.domain';
import { getFormattedPrice } from './getFormattedPrice';
import { URLs } from '../constants/urls';

export const optionsToSelectorMapper = (
    options: TOptionsValues,
    {
        decline,
        base,
        ticketsSum,
        required,
        isSelected,
    }: {
        decline?: '0' | '1';
        base?: string;
        ticketsSum?: string;
        required?: string;
        isSelected?: boolean;
    }
) => {
    const declineValue =
        decline && +decline ? [{ label: 'Decline', value: '0', image: '', price: '' }] : [];
    const emptyOption =
        (required && +required) || declineValue.length
            ? []
            : (isSelected && [{ label: 'None', value: '', image: '', price: '' }]) || [];
    const isPercents = base === '%';

    const filteredOptions = Object.values(options).filter(({ is_disabled }) => !+is_disabled);

    const list = filteredOptions.length ? filteredOptions : Object.values(options);

    const result = list.map(({ name, id, price, has_image }) => ({
        label: name,
        value: id,
        image: has_image ? `${URLs.image}/option_value/${id}/center/160x120/wr.jpg` : '',
        price: isPercents
            ? ticketsSum && +ticketsSum
                ? `$${(+ticketsSum * (+price / 100)).toFixed(2)}`
                : `${+price}%`
            : `${+price ? getFormattedPrice(+price) : ''}`,
    }));

    return [...emptyOption, ...result, ...declineValue];
};
